export const ACCOMMODATION_TILE = {
    IMAGE_COUNT: 1,
    LAYOUT_BREAKPOINT: 'md',
    // Matches the Chakra UI v3 default 'md' breakpoint used in the <picture> <source media> query.
    LAYOUT_BREAKPOINT_EM: '48em',
    MAX_MOBILE_BADGES: 2,
    MAX_MOBILE_RATE_PLAN_FEATURES: 2,
    MAX_AMENITIES: 5,
};
